import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/shared/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class OperatorsService {
  constructor(private http: HttpClient, private authService: AuthService) {}

  private url(path: string): string {
    const base =
      this.authService.getOriginCurrency() !== 'BRL'
        ? environment.intlUrl
        : environment.apiUrl;

    return `${base}${path}`;
  }

  getPreAccounts(): Observable<any> {
    return this.http.get<any>(this.url('/account/preaccount'));
  }

  getAccountListCnpj(cnpj: string): Observable<any> {
    let qp = new HttpParams().set('cnpj', cnpj);
    return this.http.get<any>(this.url('/getaccountlistcnpj'), { params: qp });
  }

  getProductRegistration(pageSize: number, page: number): Observable<any> {
    let qp = new HttpParams()
      .set('pageSize', pageSize)
      .set('page', page);

    return this.http.get<any>(this.url('/product-registration'), { params: qp });
  }

  getLicensingRegistration(pageSize: number, page: number): Observable<any> {
    let qp = new HttpParams()
      .set('pageSize', pageSize)
      .set('page', page);

    return this.http.get<any>(this.url('/getlicensingRegistration'), { params: qp });
  }

  getPlatform(pageSize: number, page: number): Observable<any> {
    let qp = new HttpParams()
      .set('pageSize', pageSize)
      .set('page', page)
      .set('active', true);

    return this.http.get<any>(this.url('/platform-registration'), { params: qp });
  }
}